export const getBrowserInfo = () => {
  return {
    browserName: navigator.vendor,
    browserType: navigator.userAgent,
    deviceType: window.navigator.userAgent.includes('Mobile')
      ? 'Mobile'
      : 'Desktop',
    deviceName: window.navigator.platform,
    ipAddress: window.location.hostname,
  };
};

export const isMobileUserAgent = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';

  const isIPhone = /iPhone/i.test(userAgent);
  const isAndroidPhone =
    /Android/i.test(userAgent) && /Mobile/i.test(userAgent);
  const isOtherMobile = /webOS|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );

  return isIPhone || isAndroidPhone || isOtherMobile;
};

export const isTabletUserAgent = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';

  const isIPad =
    /iPad/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1);
  const isAndroidTablet =
    /Android/i.test(userAgent) && !/Mobile/i.test(userAgent);

  return isIPad || isAndroidTablet;
};
